import { render, staticRenderFns } from "./Dashboardv1.vue?vue&type=template&id=7581c77b&"
import script from "./Dashboardv1.vue?vue&type=script&lang=js&"
export * from "./Dashboardv1.vue?vue&type=script&lang=js&"
import style0 from "./Dashboardv1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports